module.exports = __webpack_public_path__ + "img/requirement-car@2x.7f273471.png";